module.exports = { "default": require("core-js/library/fn/object/keys"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/babel-runtime/core-js/object/keys.js
// module id = 123
// module chunks = 0